module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _vm._v(" "), _c('el-input', {
    attrs: {
      "placeholder": "Filter keyword"
    },
    model: {
      value: (_vm.filterText),
      callback: function($$v) {
        _vm.filterText = $$v
      },
      expression: "filterText"
    }
  }), _vm._v(" "), _c('el-tree', {
    ref: "tree2",
    staticClass: "filter-tree",
    attrs: {
      "accordion": "",
      "data": _vm.loc.regions,
      "props": _vm.defaultProps,
      "filter-node-method": _vm.filterNode
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var node = ref.node;
        var data = ref.data;

        return _c('span', {}, [_c('b', {
          class: _vm.styleType(data.type)
        }, [_vm._v(_vm._s(node.label))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(data.type))])])
      }
    }])
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', [_c('i', {
    staticClass: "fa fa-map-pin"
  }), _vm._v(" Localities")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-58405a2c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Locality.vue
// module id = 1503
// module chunks = 0